import { useCallback } from 'react';
import { ariaDescribedByIds } from '@rjsf/utils';

import type { SetStateAction } from 'react';
import type { GenericObjectType, WidgetProps } from '@rjsf/utils';

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/ui/Select';

import { Wrapper } from '../shared';

interface ISelectWidget<T, S, F> extends Omit<WidgetProps<T, S, F>, 'value'> {
	value: string;
}

const Widget = <T, S, F>({
	disabled,
	formContext = {} as F,
	id,
	onChange,
	options,
	placeholder,
	readonly,
	value = '',
	name,
	registry,
	schema
}: ISelectWidget<T, S, F>) => {
	const { readonlyAsDisabled = true } = formContext as GenericObjectType;

	const formData = registry.formContext?.formData;
	const enumOptions = options?.enumOptions?.filter(({ schema }) => schema?.parentId == formData.subDirection) ?? [];

	const handleChange = useCallback((nextValue: SetStateAction<string>) => {
		if (nextValue) {
			if (schema?.type === "number") {
				onChange(nextValue === null ? schema.default : +nextValue || schema.default);

				return;
			}

			onChange(nextValue === null ? schema.default : nextValue || schema.default);
		}
	}, [schema]);

	return (
		<Select
			onValueChange={!readonly ? handleChange : undefined}
			disabled={disabled || (readonlyAsDisabled && readonly) || !enumOptions.length}
			aria-describedby={ariaDescribedByIds<T>(id)}
			value={value}
			name={name}
		>
			<SelectTrigger className="w-full">
				<SelectValue placeholder={placeholder} />
			</SelectTrigger>

			<SelectContent>
				<SelectGroup>
					{enumOptions.map(({ value, label }) => (
						<SelectItem key={`option-${value}`} value={value}>
							{label}
						</SelectItem>
					))}
				</SelectGroup>
			</SelectContent>
		</Select>
	);
}

const SubSubDirectionWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { SubSubDirectionWidget };
